import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "antd/dist/antd.css";
import "antd/dist/antd.variable.min.css";
import "./styles/global.scss";


import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ConfigProvider } from "antd";
import { Provider } from 'react-redux';
import { store } from "./redux/store";
import faIR from "antd/es/locale/fa_IR";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      //staleTime: 3*(60*1000), // minute * (milliesecond * 100 to convert second)
      //cacheTime: 3*(60*1000), // minute * (milliesecond * 100 to convert second)
    },
  },
});

ConfigProvider.config({
  theme: {
    primaryColor: "#42424c",
    errorColor: "#fe3741",
    borderRadiusBase: "20px",
  },
});


//ReactDOM.render(
//  <React.StrictMode>

//  </React.StrictMode>,
//  document.getElementById("root")
//);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ConfigProvider direction="rtl" locale={faIR}>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <App />
        </Provider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ConfigProvider>
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
